import privacy from '@/locales/en/privacy'
import termsOfService from '@/locales/en/terms-of-service'
import spacialRules from '@/locales/en/spacial-rules'
import protocol from '@/locales/en/protocol'
import KycPrivacy from '@/locales/en/kyc-privacy'
import serviceCertification from '@/locales/en/service-certification'

const en = {
  Username: 'Username',
  Password: 'Password',
  login_email: 'Login Email',
  login_password: 'Login Password',
  no_account: 'No account?',
  forget_password: 'Forgot your password?',
  go_to_register: 'Go to register',
  log_in: 'Log in',
  phone_number: 'Phone number',
  please_enter_phone_number: 'Please enter phone number',
  please_enter_a_new_phone_number: 'Please enter a new phone number',
  get_code: 'Get Code',
  not_my_number: 'Not my number',
  log_out: 'Log out',
  group_of_companies: 'Group of Companies',
  log_out_tips: 'You have been logged out due to inactivity',
  okay: 'Okay',
  sms_verification_code: 'SMS Verification code',
  settings: 'Settings',
  profile: 'Profile',
  transaction_list: 'Transaction List',
  transaction_detail: 'Transaction Details',
  fee: 'Fee',
  blue_pay_balance: 'BluePay Balance',
  balance: 'Balance',
  bluepay_balance: 'BluePay Balance',
  available_balance: 'Available Balance',
  reserve_balance: 'Reserve Balance',
  withdrawable_balance: 'Withdrawable Balance',
  more_info: 'More info',
  transferable_balance: 'Transferable Balance',
  available_amount: 'Available amount',
  top_up_method: 'Top Up Method',
  estimated_fee: 'Estimated fee',
  view_detail: 'View Details',
  step: 'Step',
  add_bank_card: 'Add Bank Card',
  bank_card_detail: 'Bank Card Details',
  bank: 'Bank',
  account_name: 'Account Name',
  account_id: 'Account ID',
  mobile_phone_number: 'Mobile phone number',
  save: 'Save',
  del_bankcard: 'Deactivate',
  my_conected_bank_accounts: 'My Conected Bank Accounts',
  bank_card_limit_1: 'Temporarily does not support deleting the last bank account',
  bank_card_limit_5: 'You can add up to 5 bank cards',
  del_this_bank: 'Yes, deactivate this account',
  submit: 'Submit',
  complete: 'Complete',
  next: 'Next',
  id_card: 'ID card',
  passport: 'Passport',
  other: 'Other',
  transaction_date: 'Transaction Date',
  nationality: 'Nationality',
  first_name: 'First Name',
  last_name: 'Last Name',
  id_type: 'ID Type',
  reason: 'Reason',
  type: 'Type',
  card_id: 'Card ID',
  laser_id: 'Laser ID',
  resubmit: 'Resubmit',
  authentication_failed: 'Personal information authentication failed, Please try again',
  dyna_upload_id_portrait_missing: 'No ID photo image was detected',
  industry: 'Occupation',
  clear: 'Clear',
  date_of_birth: 'Date of Birth',
  handwritten_signature: 'Handwritten Signature',
  id_card_address: 'Province, District, Subdistrict',
  street_address: 'Address',
  confirm: 'Confirm',
  total_amount: 'Total Amount',
  amount_to_be_paid: 'Amount to be paid',
  logout_account: 'Sign Out',
  upload_avatar: 'Upload avatar',
  identity_information: 'Identity Information',
  bank_account: 'My Connected Bank Accounts',
  promotion: 'Promotion',
  mobile_top_up_discount_promo: 'Mobile Top Up Discount Promo',
  expiration: 'Expiration',
  use_now: 'Use Now',
  selected: 'Selected',
  use_conditions: 'Use conditions',
  unavailable_reason: 'Unavailable Reason',
  close_tip: 'The activity has been closed',
  useAble_tip: 'Exceeding the limit of promotional activities',
  off: 'OFF',
  unlink: 'Unlink',
  notifications: 'Notifications',
  transaction_number: 'Transaction Number',
  problem_description: 'Problem Description',
  submission_time: 'Submission Time',
  customer_complaint_type: 'Customer Complaint Type',
  feedback_and_complaint: 'Feedback and Complaints',
  view_more: 'View more',
  history: 'History',
  proceed: 'Proceed',
  select: 'select',
  bank_name: 'Bank Name',
  bank_account_no: 'Bank Account No.',
  bank_account_holder: 'Bank Account Holder',
  copy_of_bank_passbook_wallet: 'Copy of Bank Passbook/E-wallet',
  old_password: 'Old Password',
  new_password: 'New Password',
  confirm_password: 'Confirm Password',
  filter: 'Filter',
  status: 'Status',
  reset: 'Reset',
  channel: 'Channel',
  transaction_type: 'Transaction Type',
  details: 'Details',
  amount: 'Amount',
  mobile_no: 'Mobile No.',
  select_amount: 'Select Amount',
  method: 'Payment Method',
  account_number: 'Account Number',
  cash_out_fee: 'Cash Out Fee',
  amount_to_receive: 'Amount to Receive',
  detail_confirmation: 'Detail Confirmation',
  tips: 'Tips',
  transaction_details: 'Transaction Details',
  max_size_tips: 'The image size cannot exceed 20M',
  upload_proof: 'Upload Proof',
  upload: 'Upload',
  up_to: 'Up To',
  download: 'Download',
  top_up_amount: 'Top Up Amount',
  mobile_top_up_amount: 'Mobile Top Up Amount',
  discount_amount: 'Discount Amount',
  discount: 'Discount',
  date_and_time: 'Date and Time',
  top_up_fee: 'Top Up Fee',
  copied: 'Copied!',
  thai_qr_code: 'Thai QR Code',
  payment_successful: 'Payment Successful',
  transaction_processing: 'Transaction processing',
  transaction_fee_included: 'Transaction fee included:',
  transaction_fee: 'Transaction Fee',
  payment_channel: 'Payment Channel',
  transaction_id: 'Transaction ID',
  create_time: 'Create Time',
  complete_time: 'Complete Time',
  payer: 'Payer',
  payer_bank: 'Payer Bank',
  payer_account: 'Payer Account',
  payer_account_name: 'Payer Account Name',
  send_to: 'Send To',
  no_more: 'No More',
  all: 'All',
  effective: 'Effective',
  expired: 'Expired',
  closed: 'Closed',
  unavailable: 'Unavailable',
  balance_change_details: 'Balance Change Details',
  voucher: 'Voucher',
  replies: 'Replies',
  receipt: 'Receipt',
  view: 'View',
  camera: 'Camera',
  album: 'Album',
  processing: 'Pending',
  success: 'Success',
  failed: 'Failed',
  waiting: 'Waiting',
  top_up_success: 'Top Up Success',
  top_up_failed: 'Top Up Failed',
  top_up_processing: 'Top Up Pending',
  cash_out_success: 'Cash Out Success',
  cash_out_failed: 'Cash Out Failed',
  cash_out_processing: 'Cash Out Pending',
  transfer_out_success: 'Transfer Out Success',
  transfer_out_failed: 'Transfer Out Failed',
  transfer_out_processing: 'Transfer Out Pending',
  mobile_top_up_success: 'Mobile Top Up Success',
  mobile_top_up_failed: 'Mobile Top Up Failed',
  mobile_top_up_processing: 'Mobile Top Up Pending',
  replicating_fail: 'Replicating Fail',
  replicating_success: 'Replicating Success',
  submit_successfully: 'Submit Successfully',
  current_audit_status: 'Current Audit Status',
  remark: 'Remark',
  amount_unpaid: 'Amount Unpaid',
  amount_paid: 'Amount Paid',
  id_photos: 'ID Photos',
  upload_a_photo: 'Upload a selfie with your ID',
  signature: 'Signature',
  clear_signature: 'Clear Signature',
  view_guidelines: 'View Guidelines',
  id_number: 'ID Number',
  overview: 'Overview',
  collapse: 'Collapse',
  expand: 'Expand',
  pay: 'Pay',
  view_payment_history: 'View Payment History',
  delivery_bills_amount_due: 'Delivery Bills Amount Due',
  delivery_bills_unpaid_amount: 'Delivery Bills Unpaid Amount',
  cod_settlement_bills: 'COD Settlement Bills Amount',
  delivery_bills_paid_amount: 'Delivery Bills Paid Amount',
  delivery_bills_total_amount: 'Delivery Bills Total Amount',
  cod_settlement_bills_total_amount: 'COD Settlement Bills Total Amount',
  cod_settlement_bills_paid_amount: 'COD Settlement Bills Paid Amount',
  payment_complete: 'Payment Complete',
  checkout_paid_history: 'Check Paid History',
  ver_code: 'Verification Code',
  please_make_sure_the_information_correct:
    'Please make sure the information above is correct. Submitted transactions cannot be reversed.',
  dialog_verification_title: 'Verification Required',
  dialog_verification_content: 'Please complete your identity verification to proceed.',
  dialog_no_my_phone_content: 'Please contact J&T to update your mobile number',
  close: 'Closed',
  i_have_read: 'I have read, understood and accept',
  privacy_policy: 'Privacy Policy',
  terms_and_conditions: 'Terms and Conditions',
  the_special_rules_for_user: 'the Special Rules for Users of J&T Wallet',
  special_rules: 'Special Rules for Users of J&T Wallet Function Powered by Bluepay',
  start_verification: 'Start Verification',
  global_jet_express: 'Global Jet Express',
  and_the_following: 'and the following',
  companies: 'companies',
  payments_tips: "Payments will be automatically deducted, and you'll be notified without further verification.",
  payments_details_tips:
    'Payment details will be sent to your Bluepay Wallet. Please check your transaction list for updates.',
  agree_gray: 'By activating auto-debit, you agree to the',
  agree_red: 'Payment Authorization Service Agreement',
  account_settings: 'Account Settings',
  auto_debit_activate: 'Auto-Debit Activation',
  auto_debit: 'Auto-Debit',
  bluepay_account_id: 'Bluepay Account ID',
  payment_method: 'Payment Method',
  termination_completed: 'Termination Completed',
  jt_1: 'Global Jet Express',
  jt_2: ' (Thailand) Co., Ltd.',
  payment_details: 'Payment Details',
  auto_debit_tip_1: "Payments will be automatically deducted, and you'll be notified without further verification",
  auto_debit_tip_2:
    'The information for Auto-Debit payments will be notified through Bluepay wallet. Please check the transaction list for details.',
  auto_debit_terminate: 'Terminate Auto-Debit',
  terminate_auto_debit: 'Auto-Debit Terminated',
  protocol_1: 'Payment Authorization Service Agreement',
  protocol_2: 'for more information or concerns',
  protocol_3: 'By activating auto-debit, you agree to the',
  protocol_4: 'Visit the ',
  activation_successful: 'Activation Successful',
  terminate_tip_1: 'Are you sure you want to terminate your auto-debit payment',
  terminate_tip_2: 'This will stop all future auto-debit payments to this merchant',
  enter_verification_code: 'Enter verification code',
  activation_date_time: 'Activation Date & Time',
  termination_date_time: 'Termination Date & Time',
  merchant: 'Merchant',
  authorization_has_been_completed: 'Authorization has been completed',
  auto_debit_payment_method: 'Auto-Debit Payment Method',
  bill_type: 'Bill Type',
  bill_status: 'Bill Status',
  create_date: 'Create Date',
  bill_amount: 'Bill Amount',
  bill_paid_amount: 'Bill Paid Amount',
  bill_number: 'Bill Number',
  merchant_order_id: 'Merchant Order ID',
  bill_final_payment_date: 'Bill Final Payment Date',
  bill_create_time: 'Bill Create Time',
  bill_complete_time: 'Bill Complete Time',
  clear_status: 'Clear Status',
  clear_amount: 'Clear Amount',
  clear_reference_number: 'Clear Reference Number',
  related_transaction_id: 'Related Transaction ID',
  related_wallet_transaction_id: 'Related Wallet Transaction ID',
  clear_type: 'Clear Type',
  clear_create_time: 'Clear Create Time',
  clear_complete_time: 'Clear Complete Time',
  merchant_name: 'Merchant Name',
  transfer_amount: 'Transfer Amount',
  receiver_account: 'Receiver Account',
  receiver_account_name: 'Receiver Account Name',
  transfer_out_fee: 'Transfer out Fee',
  upload_id: 'Upload ID',
  face_recognition: 'Face Recognition',
  dyna_face_scan_ready_title: 'Get ready to scan your face',
  dyna_face_scan_tips_title: 'Scan face tips',
  dyna_face_scan_tip_1: "Make sure you're in a well-lit room",
  dyna_face_scan_tip_2: 'Place your face within the frame',
  dyna_face_scan_tip_3: 'Wait a few seconds for automatic scanning',
  dyna_face_scan_tip_4: "Please don't wear a mask when scanning",
  dyna_face_scan_tip_5: 'Keep your eyes open and look at the camera',
  dyna_face_scan_cta: 'Go to Scan',
  dyna_face_scan_illustration_alt: 'Face scan guide placeholder illustration',
  dyna_face_scan_config_missing: 'LiveWeb face scan is not configured yet. Please set account_id and app_key first.',
  dyna_face_scan_image_fetch_failed: 'Unable to retrieve the best face image. Please try scanning again.',
  dyna_face_scan_image_timeout: 'Fetching the best face image timed out. Please try scanning again.',
  dyna_face_scan_image_not_found: 'No matched face image was found for this request.',
  dyna_face_scan_image_cache_expired: 'The face image cache has expired. Please start a new scan.',
  dyna_face_scan_image_auth_failed: 'LiveWeb image authentication failed. Please verify the SDK credentials.',
  open_camera: 'Open Camera',
  face_tips: 'Please use your camera to continue',
  confirm_information: 'Confirm Information',
  id_card_information: 'ID Card Information',
  en_first_name: 'English First Name',
  full_name: 'Full Name',
  en_last_name: 'English Last Name',
  laser_number: 'Laser Number',
  date_of_issue: 'Date of Issue',
  date_of_Expire: 'Date of Expire',
  additional_information: 'Additional Information',
  monthly_income: 'Monthly Income',
  email: 'Email',
  Verifying_your_identity: 'Verifying your identity…',
  This_may_take_a_few_seconds: 'This may take a few seconds. Please don’t close the app.',
  Facial_Recognition_Failed: 'Facial Recognition Failed',
  Make_sure_your_face_is_centered: 'Make sure your face is centered and well-lit,\n then try again.',
  Try_Again: 'Try Again',
  Return: 'Return',
  register_address: 'Register Address',
  Country: 'Country',
  Sex: 'Sex',
  Issuing_State: 'Issuing State',
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  Current_Address: 'Current Address',
  Street_Address: 'Street Address',
  Address_Details: 'Address Details',
  Work_Location: 'Work Location',
  Work_Street_Address: 'Work Street Address',
  Occupation: 'Occupation',
  Wallet_Usage_Purpose: 'Wallet Usage Purpose',
  Upload_Selfie_with_ID: 'Upload Selfie with ID',
  dyna_upload_id_subtitle: 'Please ensure good lighting and a clear view of your ID document.',
  dyna_upload_id_front_side: 'Front Side of the document',
  dyna_upload_id_back_side: 'Back Side of the document',
  dyna_upload_passport_page: 'Passport information page',
  dyna_upload_id_privacy_notice: 'We will protect your personal information in accordance with Thai law',
  Daily_Expenses_Payments: 'Daily Expenses/Payments',
  Money_Transfer: 'Money Transfer',
  Bill_payment: 'Bill payment',
  Investment_Savings: 'Investment/Savings',
  Donations_Charity: 'Donations/Charity',
  Online_Shopping_E_Commerce: 'Online Shopping/E-Commerce',
  Business_Merchant_Services: 'Business/Merchant Services',
  Clear_Signature: 'Clear Signature',
  ID_Front: 'ID Front',
  ID_Back: 'ID Back',
  Selfie_with_ID: 'Selfie with ID',
  Please_enter_the_correct_email_address: 'Please enter the correct email address',
  Please_enter_the_correct_identification: 'Please enter the correct identification number',
  Please_enter_the_correct_Laser_ID: 'Please enter the correct Laser ID',
  Purpose_Description: 'Purpose Description',
  Please_enter_the_correct_information_required_address: 'House No.,Moo ,Soi,Road,Postal Code',
  Please_enter_the_correct_information_required: 'Please enter the correct information as required.',
  confirm_submit:
    'Submission confirmed. Your information is under review. Our working hours are from 8:00 to 22:00, and your information will be processed within 1 hour during these hours. For assistance, please email our customer support at: onboard@bluepay.asia',
  permission_request_title: 'Request Permission',
  Please_agree_to_the_camera_permission: 'Please agree to the camera permission',
  camera_permission_required_for_verification:
    'To complete the current identity verification, we need access to your camera for facial recognition or for capturing your ID document for OCR verification. If camera permission is not granted, the system will be unable to collect the required verification information, and you will not be able to continue to the next step.',
  how_to_take_a_selfie_with_your_id: 'How to Take a Selfie with Your ID:',
  how_to_take_a_selfie_tips_1: '1. Hold your valid ID next to your face.',
  how_to_take_a_selfie_tips_2: '2. Make sure your face and ID are clearly visible.',
  how_to_take_a_selfie_tips_3: '3. Use a well-lit area with a plain background.',
  how_to_take_a_selfie_tips_4: '4. Remove any face masks, hats, or sunglasses.',
  how_to_take_a_selfie_tips_5: '5. Make sure the ID details are not blurry or blocked.',
  got_it: 'Got It',
  account_activated: 'Account Activated!',
  account_activated_content:
    'Success! Your personal information has been verified. You can now top up, cash out, and transfer using your account.',
  I_agree_to_the: 'I agree to the',
  kyc_service_agreement_certification: 'Privacy Policy for the KYC process',
  Upload_proof_of_employment: 'Upload proof of employment',
  Top_Up_Toast:
    "We're currently reviewing your information. You'll be able to make Top-Up once the review is approved.",
  Cash_Out_Toast:
    "We're currently reviewing your information. You'll be able to make Cash-Out once the review is approved.",
  Transfer_Toast:
    "We're currently reviewing your information. You'll be able to make Transfer once the review is approved.",
  mobile_top_up_Toast:
    "We're currently reviewing your information. You'll be able to make Mobile Top up once the review is approved.",
  job_title: 'Job title',
  Official_Workplace: 'Official Workplace',
  Failure_Reason: 'Failure Reason',
  Foreigner: 'Foreigner',
  Thailand: 'Thailand',
  face_title_text: 'Please Use the Correct ID Type',
  face_tip_text:
    'Thai nationals can only use National ID card for verification. Please upload the correct ID and try again.',
  fee_waived: 'Fee waived by J&T',
  expected_deposit_time: 'Expected deposit time',
  two_work_hours: '2 working hours',
  failure_reason: 'Failure Reason',
  proof_of_transfer: 'Proof of transfer',
  per_top_up_limit: 'Per-Top Up limit',
  daily_remaining: 'Daily Remaining',
  monthly_remaining: 'Monthly remaining',
  issue_date_later_than_expiration_date: 'The document expiration date must be later than the issue date.',
  // MapString
  top_up_method_1: 'Bank Transfer',
  top_up_method_2: 'Thai QR',
  transaction_type_1: 'Top Up',
  transaction_type_2: 'Mobile Top Up',
  transaction_type_3: 'Cash Out',
  transaction_type_4: 'Mobile Top up Failed',
  transaction_type_5: 'Cash Out Failed',
  transaction_type_6: 'Cash In',
  transaction_type_7: 'Auto-Debit Payment',
  transaction_type_8: 'Transfer Out',
  transaction_type_11: 'Transfer Out Failed',
  transaction_status_1: 'Pending',
  transaction_status_2: 'Success',
  transaction_status_3: 'Failed',
  identity_audit_status_1: 'Pending',
  identity_audit_status_2: 'Approved',
  identity_audit_status_3: 'Reject',
  feedback_type_1: 'Top Up issue',
  feedback_type_2: 'Mobile-phone Top up issue',
  feedback_type_3: 'Cash Out issue',
  feedback_type_4: 'Login issues',
  feedback_type_5: 'Password issue',
  feedback_type_6: 'Submit personal information issue',
  feedback_type_7: 'Auto-Debit issue',
  feedback_type_8: 'Cash in issue',
  feedback_type_9: 'Add Bank Card issue',
  feedback_type_10: 'Transfer Out issue',
  feedback_type_11: 'Account deactivation issue',
  feedback_type_12: 'Other issue',
  feedback_type_16: 'Payment PIN Lock Issue',
  payment_method_1: 'Balance',
  auto_debit_status_1: 'Activated',
  auto_debit_status_2: 'Terminated',
  notify_type_1: 'Auto-Debit Activation',
  notify_type_2: 'Auto-Debit Terminated',
  notify_type_3: 'Successful Automatic Payment',
  notify_type_4: 'Feedback and Compliant Response',
  bills_status_1: 'Pending',
  bills_status_2: 'Processing',
  bills_status_3: 'Complete',
  bills_status_4: 'Pending Cancellation',
  bills_status_5: 'Cancelled',
  bills_type_1: 'COD Settlement Bill',
  bills_type_2: 'Delivery Bill',
  consumption_type_1: 'Payment',
  limit_level_type_1: 'Wallet Limit',
  limit_level_type_2: 'Daily Topup Limit',
  limit_level_type_3: 'Monthly Topup  limit',
  limit_level_type_4: 'Daily consumption transaction limit',
  limit_level_type_5: 'Monthly consumption transaction limit',
  limit_level_type_6: 'Daily transfer-out and cash-out limit',
  limit_level_type_7: 'Monthly transfer-out and cash-out limit',
  limit_level_type_8: 'Daily Transfer-in limit',
  limit_level_type_9: 'Monthly Transfer-in limit',
  limit_level_content_1: 'Maximum amount that can be kept in your Bluepay Wallet.',
  limit_level_content_2: 'Maximum amount that can be topped up the Bluepay Wallet per day.',
  limit_level_content_3: 'Maximum amount that can be topped up  the Bluepay Wallet per month.',
  limit_level_content_4:
    'Maximum amount that can be cumulatively spent  for payments through the BluePay Wallet per day.',
  limit_level_content_5:
    'Maximum amount that can be cumulatively spent  for payments through the BluePay Wallet per month.',
  limit_level_content_6: 'Maximum amount that can be transferred out or cashed out from the BluePay Wallet per day.',
  limit_level_content_7: 'Maximum amount that can be transferred out or cashed out from the BluePay Wallet per month.',
  limit_level_content_8: 'Maximum amount that can be transferred into the Bluepay Wallet per day.',
  limit_level_content_9: 'Maximum amount that can be transferred into the Bluepay Wallet per month.',
  // SentenceString
  agree_policy: 'I have agreed to the privacy agreement and service policy',
  enter_phone_number: '+66  Please enter your phone number',
  phone_is_required: 'Phone number is required',
  enter_password: 'Enter password',
  enter_new_password: 'Enter a new password',
  confirm_new_password: 'Confirm new password',
  question_tip: 'Any questions about this order?',
  question_tip_2: 'Having trouble adding your card?',
  login_with_password: 'Login with Password ',
  login_with_code: 'Login with Verification Code ',
  change_login_password: 'Change Login Password',
  service_and_help: 'Help Center and Customer Service',
  tip_transfer_corresponding_amount_account: 'You need to transfer the corresponding amount to this account: ',
  tip_upload_proof_transfer: 'Please upload your proof of transfer:',
  confirm_submit_transaction_tip:
    'Please make sure the information above is correct. Submitted transactions cannot be reversed.',
  this_field_is_required: 'This field is required',
  please_enter_the_correct_name_format: 'Please enter the correct name format.',
  password_inconsistency: 'The two password inputs are inconsistent',
  select_top_up_method: 'Select Top Up Method',
  receiving_bank_account: 'Receiving Bank Account',
  enter_amount: 'Enter Amount',
  please_enter_9_digits: 'Please enter 9 digits and letters',
  please_enter_12_digits_or_letter: 'Please enter 12 digits and letters',
  please_enter_13_digits: 'Please enter 13 digits',
  please_enter_least_6_digits_or_letter: 'Please enter 6 to 9 digits or letters',
  laser_id_valid_tips: 'Can only input numbers, letters, and -, no more than 20 digits',
  upload_front_photo_id: 'Upload a Photo of the Front of Your ID',
  q_1: 'How do I log into the Bluepay app?',
  a_1: 'To log into the  Bluepay app, follow these steps:Download and install the app on your mobile device. Open the app and select the "login" option on the registration page. Enter your registered phone number and the corresponding password. Click the "login" button to complete the login process.',
  q_2: 'How can I Top up in the app?',
  a_2: 'To Top up in the app, follow these steps:On the app\'s main interface, find the "Top up" and tap to enter the page. Choose the Top up method, such as bank card,  etc. Enter the Top up amount and confirm the relevant information. Proceed with the payment process based on the selected payment method. Upon successful payment, your Top up app will automatically update to reflect the Top up amount.',
  q_3: 'How can I Cash out from the app?',
  a_3: 'To withdraw funds from the app, follow these steps:On the app\'s main interface, find the "Cash out" and tap to enter the  page. Enter the Cash out amount and confirm the relevant information. Select the Cash out method (usually options like bank card,  etc. are available). Submit the Cash out request and wait for processing. Once the Cash out request is approved, the corresponding amount will be transferred to your chosen Cash out method account.',
  q_4: 'How can I  mobile phone Top up with the app?',
  a_4: 'How can I  mobile phone Top up with the app? To mobile phone Top up using the app, follow these steps:On the apps main interface, find the "Top up Mobile" and tap to enter the page. Enter the phone number and the mobile phone Top up amount. Choose the payment method and complete the payment process (e.g.,balance, etc.). After a successful mobile phone Top up, your mobile phones balance will automatically increase by the corresponding amount.',
  upload_back_photo_id: 'Upload a Photo of the Back of Your ID',
  handheld_id_photo: 'Upload Selfie With ID',
  uploading_with_dot: 'uploading...',
  loading_with_dot: 'Loading...',
  view_history: 'View History',
  enter_personal_info_bank_info: ' Please complete personal verification information and bank information',
  feedback_sent_success: 'Feedback Sent Successfully',
  please_enter: 'Please Enter',
  please_sselect_your_region: 'Please select your region',
  pls_enter_10_num: 'Please enter 10 digits',
  input_value_cannot_spaces: 'The input value cannot contain spaces',
  please_enter_two_decimal: 'Please enter a non-negative number with a maximum of 2 decimal places.',
  please_enter_non_negative_number: 'Please enter a non-negative number',
  please_sign_by_hand: 'Please sign by hand',
  please_enter_non_zero_number: 'Please enter a non zero integer',
  please_enter_two_decimal_places: 'Please enter two decimal places',
  please_enter_9_19_digits: 'Please enter 9 to 19 digits',
  please_check_info_correct: 'Please check whether the information is filled in correctly',
  there_are_unfilled_fields: 'There are unfilled fields',
  valid_password_tips: '8-15 characters, a combination of letters, numbers and symbols',
  please_enter_0_or_9_digits_phone_number: 'Please enter 0+9 digits/enter a 9-digit phone number',
  // 'privacy_sentence1': 'BluePay Company Limited (the "Company") realizes the importance of the privacy and the personal data protection of the Company\'s customers and clients (collectively called as "you"). Thus, the Company has established the Privacy Policy and to notify you regarding the Company\'s guideline for the collection, use and disclosure of personal data in order to enable you to confidently use electronic money service via BluePay  application (the "Application"), payment service, money transfer service via electronic methods and other services as approved by Bank of Thailand, which are currently available and may be available in the future, including but not limited to any services relating to the usage of applications, websites and other channels provided by the Company (collectively called as the "Services").',
  // 'privacy_title1': 'Personal Data',
  // 'privacy_sentence2': '"Personal Data" means the information relating to a person, which enables the identification of such person, whether directly or indirectly, but not including the information of the deceased persons in particular, such as name-surname, identification card number, address, telephone number, financial transaction.',
  // 'privacy_sentence3': 'Personal Data may consist of sensitive information and at risk of being treated unfairly (Sensitive Personal Data) such Personal Data includes but not limited to biometrics data, data relating to religious.',
  // 'privacy_sentence4': 'In this regard, such Personal Data includes any information provided by you to the Company and/or being in the Company\'s possession and/or lawfully collected by the Company from any other sources or any other persons.',
  // 'privacy_sentence5': 'In case where necessary for the Company to collect, use or disclose your Personal Data which is out of the scope as specified in this Privacy Policy, the Company will inform you regarding such different characteristics at the time or prior to the collection, use or disclosure of your Personal Data.',
  // 'privacy_sentence6': 'By using the Services, it is considered that you have read and understood this Privacy Policy. Otherwise, please immediately stop using the Service.',
  // 'privacy_title2': 'Type of Personal Data Collected, Used or Disclosed by the Company',
  // 'privacy_sentence7': 'Information on identification card, passport and/or other evidence issued by government authorities such as identification card number, name, surname, name prefix, signature;',
  // 'privacy_sentence8': 'Necessary contact information such as contactable address, telephone number;',
  // 'privacy_sentence9': 'Particular personal characteristics such as status, biometrics data, photo;',
  // 'privacy_sentence10': 'Education and/or career information;',
  // 'privacy_sentence11': 'Financial information such as records of transactions made through BluePay accounts or other Services, credit card information, deposit account information;',
  // 'privacy_sentence12': 'Information relating to your devices, system, and usage behaviors, including but not limited to device identity number in relation to network connection (such as IP address, MAC address, Device ID), Advertisement ID, mobile device operating systems, mobile network service provider, location, device usage details, cookies, phonebook, application usage, technical information, model and type of devices, photo, image and photo album .',
  // 'privacy_sentence13': 'For the necessity of providing additional services apart from fundamental Services or the collection, use, disclosure of Sensitive Personal Data other than those specified above, the Company will perform the processing under legal basis as prescribed by law only. In this regard, the Company will inform the purpose and type of Personal Data required to be collected, used or disclosed prior to or at the time of such processing.',
  // 'privacy_title3': 'Basis of the Collection, Use and Disclosure of your Personal Data and the Purposes of such Processing',
  // 'privacy_sentence14': 'The Company will collect, use or disclose your Personal Data under legal basis and in accordance with the following purposes:',
  please_enter_less_amout_than_balance: 'Please enter an amount less than the available balance',
  please_enter_less_amout_than_withdraw_balance: 'Please enter an amount less than the withdrawable balance',
  please_enter_less_amount_than_transferable_balance: 'Please enter an amount less than the transferable balance',
  submit_bank_info_tips: 'Are you sure your bank card information is correct?',
  delete_bank_info_tips: 'Are you sure you want to deactivate this account?',
  insufficient_balance: 'Insufficient Balance',
  reserve_balance_note: 'Reserve Balance Note:',
  overview_help: 'Overview Help',
  delivery_bills_unpaid_amount_tips: '- refers to the total unpaid amount of Delivery Bills.',
  delivery_bills_amount_due_tips: '- refers to refer to the total amount of the Delivery Bills you need to pay now.',
  cod_settlement_bills_tips:
    '- refers to refer to the Cash on Delivery (COD) payments that J & T collects from customers on your behalf and settles to you',
  delivery_bills_paid_amount_tips: '- refers to the total amount of the Delivery Bills you have already paid.',
  delivery_bills_total_amount_tips: '- refers to the total amount of the Delivery Bills issued.',
  the_fund_reserve_for_paying_delivery_bills:
    'The amount is the total cost of the delivery bill that needs to be paid. The fund reserved for paying delivery bills only, which can not be withdrawn. Please contact J&T if you have any questions regarding this.',
  the_fund_frozen_for_paying_delivery_bills:
    'The amount is the total cost of the delivery bill that needs to be paid. The fund reserved for paying delivery bills only, which can not be cash out. Please contact J&T if you have any questions regarding this.',
  valid_bank_phone: 'Must be greater than 6 digits',
  topup_mobile_tips:
    'Your transaction amount has exceeded the limit. Please provide your personal information for further transactions',
  services: 'Services',
  pay_in_qr_tips:
    'Take a screenshot(suggest)/download the QR code, then use one of the following apps to proceed with payment',
  qr_screen_or_download:
    'Please take a screenshot or copy the download link to open it in your browser, save the QR code, and scan it with a supported payment app to complete your payment.',
  copy_download_link: 'Copy Download Link',

  pay_in_qr_tips_jt: 'Take a screenshot/download the QR code, then proceed with the payment using the applicable app.',
  screen_qr_jt: 'Please screenshot the QR code and scan it with a supported payment app to complete your payment.',
  you_have: 'You have',
  unread_messages: 'unread messages',
  are_you_sure_to_submit: 'Are you sure to submit?',
  up_to_5_images_can_be_uploaded: 'Up to 5 images can be uploaded',
  wallet_balance_limit: 'Wallet Balance Limit',
  wallet_balance_limit_content:
    'The total amount you can add to your wallet each day, including top-ups and incoming transfers.',
  unauthorized: 'Unauthorized',
  basic_account: 'Basic Account',
  semi_verified: 'Semi-Verified',
  fully_verified: 'Fully Verified',
  view_benefits: 'View Benefits',
  verify_account: 'Verify Account',
  why_we_require_verification: 'Why We Require Verification',
  verification_reason:
    'To meet the regulations of the Bank of Thailand and protect your funds, BluePay uses account verification levels with specific transaction limits.',
  verification_reason_jt:
    'To meet the regulations of the Bank of Thailand and protect your funds, J&T Wallet uses account verification levels with specific transaction limits. These requirements help:',
  verification_help: 'These requirements help:',
  why_are_account_tiers_important: 'Why Are Account Tiers Important?',
  important_reason:
    'Under the Payment Systems Act and Anti-Money Laundering (AML/CFT) laws in Thailand, e-wallets must verify user identities (KYC) and apply transaction limits based on account risk levels.',
  prevent_financial_crimes: 'Prevent financial crimes (fraud, money laundering)',
  secure_your_account: 'Secure your account',
  ensure_safe: 'Ensure safe and compliant payment services',
  account_features: 'Account Features',
  account_type: 'Account Type',
  view_balance: 'View Balance',
  cash_in: 'Cash In',
  payment: 'Payment',
  transaction_history: 'Transaction History',
  receive_money: 'Receive Money',
  send_money: 'Send Money',
  age_more_than_15: 'Users Aged 15 and Above',
  age_lest_than_15: 'Users Under 15 Years Old',
  non_thai_id_card: 'Users with Non-Thai ID Cards',
  wallet_balance: 'Wallet Balance',
  wallet_dialog_confirm: 'Verify My Account',
  wallet_dialog_title: 'Wallet Limit Reached',
  warn_dialog_title: 'Wallet Limit Warning',
  dismiss: 'Dismiss',
  wallet_dialog_content_left: "Transaction amount exceeds the recipient's single receiving limit (Max: ฿",
  wallet_dialog_content_right: '). Please reduce the amount',
  warn_dialog_content_left: "You've reached your BluePay balance limit of",
  warn_dialog_content_right: 'Please spend or transfer funds before adding more.',
  per_transaction: 'Per-Transaction',
  daily_cumulative: 'Daily Cumulative',
  monthly_transaction: 'Monthly Transaction',
  consumption: 'Consumption',
  transfer_out: 'Transfer Out',
  transfer_in: 'Transfer In',
  unlimited: 'Unlimited',
  please_upload_supporting_documents: 'Please upload supporting documents',
  upload_image_here: 'Upload image here',
  please_upload_you_information: 'Please confirm your information',
  laser_umber: 'Laser Number',
  service_agreement_certification: 'Privacy Policy  the Credit Limit Upgrade Process',
  could_not_complete_verification: "We couldn't complete your verification",
  could_not_complete_verification_content_1: 'There was an issue with your submission: ',
  could_not_complete_verification_content_2: 'Please update your information and try again.',
  try_again: 'Try Again',
  submit_for_manual: 'Submit for manual review instead',
  auth_failed: 'Authentication Failed',
  failed_reason: 'There was an issue with the: ',
  upload_photo: 'Upload Photo',
  upload_photo_tips: 'Your information has been uploaded and is now under review.',
  dopa_status_tips:
    'Your account has been successfully upgraded. You now have access to all features and increased transaction limits.',
  in_review: 'In Review',
  supporting_documents: 'Supporting Documents',
  left: 'left',
  used_out_of: 'used out of ',
  dopa_success: 'Verification Successful! ',
  dopa_success_content:
    'Your account has been successfully upgraded. You now have access to all features and increased transaction limits.',
  dopa_review: 'Your information is now under review. ',
  dopa_review_content1:
    'Our working hours are from 8:00 AM to 10:00 PM, and your submission will be processed within 1 hour during these hours.',
  dopa_review_content2: 'For any assistance, feel free to contact our customer support at ',
  you_can_upload_up_to_5_supporting_documents: 'You can upload up to 5 supporting documents',
  view_supported_guidelines: 'View Supported IDs and Documents',
  supported_guidelines: 'Supported IDs and Documents',
  work_permit_related_documents: 'Work Permit Related Documents',
  work_permit_book: 'Work Permit (Book)',
  work_permit_card: 'Work Permit (Card)',
  work_permit_passport: 'Passport with NON-B',
  work_permit_receipt: 'Work Permit Receipt (Copy or Original)',
  other_acceptable_documents: 'Other Acceptable Documents',
  other_thai_house: 'Thai House Registration',
  other_thai_driving: 'Thai Driving License',
  other_password_non: 'Passport with Non-Immigrant Visa',
  other_password_student: 'Passport with Student Visa',
  other_alien_ident: 'Alien Identification Card',
  tips_balance_l: 'Your Bluepay balance cannot exceed ฿',
  tips_balance_r: '. Please reduce the amount or upgrade your account level first.',
  tips_balance_r_highest: '. Please reduce the amount or consume  first.',
  tips_single_l: 'Transaction amount exceeds single payment limit (Max: ฿',
  tips_daily_l: 'Daily payment total has reached ฿',
  tips_amount_limit: '(Limit: ฿',
  tips_amount_remain: ', Remaining: ฿',
  tips_daily_r: '). Continuing will exceed limits. Upgrade your account to increase limits',
  tips_tran_r_highest: '). Continuing will exceed limits. ',
  tips_monthly_l: 'Monthly payment total has reached ฿',
  tips_monthly_r: '). Continuing will exceed limits. Upgrade your account to increase limits',
  powered_by_bluepay: 'POWERED BY BLUEPAY',
  settle_shipments_quickly: 'Settle shipments quickly.',
  with_j_t_bill: 'With J&T Bills, you can easily pay your shipments quick.',
  document_expired: 'Document Expired',
  document_expired_tips: 'The document you submitted has expired. Please upload a valid document and try again.',
  top_up_two_tips_title: 'Processing Time',
  top_up_two_tips_1: 'Business hours (9:00 AM - 3:00 PM): Funds arrive within 2 hours',
  top_up_two_tips_2: 'Outside business hours or on weekends: Funds will arrive by 10:00 AM on the next business day',
  // PageTitleString
  login: 'Login',
  register: 'Register',
  reset_password: 'Reset Password',
  privacy: 'Privacy',
  privacy_agreement: 'Privacy Policy',
  terms_of_service: 'Terms of Service',
  bluepay_service_policy: 'BluePay Terms of Service',
  the_special_rules: 'The Special Rules',
  service_policy: 'Service Policy',
  language: 'Language',
  faq: 'FAQ',
  bank_accounts: 'Bank Accounts',
  help_center: 'Help Center',
  feedback: 'Feedback',
  feedback_history: 'Feedback History',
  page_not_found: 'Page Not Found',
  new_account: 'New Accounts',
  personal_information: 'Personal Information',
  top_up: 'Top Up',
  cash_out: 'Cash Out',
  transfer: 'Transfer',
  mobile_top_up: 'Mobile Top Up',
  mobile_number: 'Mobile Number',
  verification_code: 'Verification Code',
  mobile_verification: 'Mobile Verification',
  update_mobile_number: 'Update Mobile Number',
  activate_auto_debit: 'Activate Auto-Debit',
  jt_bills: 'J&T Bills',
  bill_details: 'Bill Details',
  bill_payment_history: 'Bill Payment History',
  bill_payment_detail: 'Bill Payment Details',
  assets: 'Assets',
  transactions: 'Transactions',
  home: 'Home',
  account: 'Account',
  inbox: 'Inbox',
  account_limits: 'Account Limits',
  verification_levels: 'Verification Levels',
  account_verification: 'Account Verification',
  you_have_no_data_yet: 'You have no data yet',
  feedback_successful:
    "Thank you for successfully submitting your feedback into our system. We've received it and will be sure to keep you posted on the progress of the issue. Should you have additional questions, feel free to contact us using the following details: csr@bluepay.asia",
  cancel: 'cancel',
  no_promotions_available: 'No promotions available.',
  all_of_promos: 'All of your promos will be shown here',
  fee_prefix_cash_out: 'Free cash-out remaining',
  fee_prefix_transfer_out: 'Free transfer-out remaining',
  this_month_0: 'this month: 0',
  this_week_0: 'this week: 0',
  today_0: 'today: 0',
  total_remain: '(Total remaining: {a}/{x})',
  this_week_month: '(This month remaining: {a}/{x})',
  today_month: '(This month remaining: {a}/{x})',
  today_week: '(This week remaining: {a}/{x})',
  today_left: 'today: {x}',
  total: '{a}/{x}',
  cash_out_this_month_0_total: 'Free cash-out remaining this month: 0',
  cash_out_this_week_0_total: 'Free cash-out remaining this week: 0',
  cash_out_today_0_total: 'Free cash-out remaining today: 0',
  cash_out_total: 'Free cash-out remaining: {a}/{x}',
  cash_out_this_month_0: 'Free cash-out remaining this month: 0',
  cash_out_this_month_x: 'Free cash-out remaining this month: {x}',
  cash_out_this_week_0_month_remain: 'Free cash-out remaining this week: 0',
  cash_out_this_week_0: 'Free cash-out remaining this week: 0',
  cash_out_this_week_x: 'Free cash-out remaining this week: {x}',
  cash_out_today_0_month_remain: 'Free cash-out remaining today: 0',
  cash_out_today_0_week_remain: 'Free cash-out remaining today: 0',
  cash_out_today_0: 'Free cash-out remaining today: 0',
  cash_out_today_x: 'Free cash-out remaining today: {x}',
  transfer_out_this_month_0_total: 'Free transfer-out remaining this month: 0',
  transfer_out_this_week_0_total: 'Free transfer-out remaining this week: 0',
  transfer_out_today_0_total: 'Free transfer-out remaining today: 0',
  transfer_out_total: 'Free transfer-out remaining: {a}/{x}',
  transfer_out_this_month_0: 'Free transfer-out remaining this month: 0',
  transfer_out_this_month_x: 'Free transfer-out remaining this month: {x}',
  transfer_out_this_week_0_month_remain: 'Free transfer-out remaining this week: 0',
  transfer_out_this_week_0: 'Free transfer-out remaining this week: 0',
  transfer_out_this_week_x: 'Free transfer-out remaining this week: {x}',
  transfer_out_today_0_month_remain: 'Free transfer-out remaining today: 0',
  transfer_out_today_0_week_remain: 'Free transfer-out remaining today: 0',
  transfer_out_today_0: 'Free transfer-out remaining today: 0',
  transfer_out_today_x: 'Free transfer-out remaining today: {x}',
  network_error_toast_1: 'Network request error, please switch networks and try again!',
  network_error_toast_2: 'Login information has expired!',
  network_error_toast_3: 'Access Permission Required',

  transaction_proof: 'Transaction Proof',
  company_information: 'Company Information',
  director_or_an_authorized: 'Are you the company director or an authorized representative?',
  company_legal_name: 'Company Legal Name',
  product_service_description: 'Product/Service Description',
  company_website: 'Company Website',
  tax_identification_number: 'Tax Identification Number',
  dbd_document: 'DBD Document',
  primary_director_information: 'Primary Director Information',
  authorized_person_information: 'Authorized person information',
  valid_id_document: 'Valid ID Document',
  for_thai_nationals: 'For Thai nationals: Upload Thai ID card',
  for_foreigners: 'For foreigners: Upload passport',
  id_front_image: 'ID Front Image',
  id_back_image: 'ID Back Image',
  bank_account_proof: 'Bank Account Proof',
  settlement_account_information: 'Settlement Account Information',
  registered_address: 'Registered Address',
  business_address: 'Business Address',
  director: 'Director',
  authorized_representative: 'Authorized Representative',
  not_required_with_passport: 'Not required if you uploaded a passport',
  select_your_account_verification_type: 'Select your account verification type',
  enterprise: 'Enterprise',
  personal: 'Personal',
  registered_address_same_as_business_address: 'Registered address is the same as business address.',
  document_upload_guidelines: 'Document Upload Guidelines',
  document_upload_guidelines_content_1:
    'Please upload a clear photo or scan of your DBD business registration document.',
  document_upload_guidelines_content_2:
    'This will be used solely for identity verification and must show the official company name and registration details.',
  auth_document_upload_guidelines_content_1:
    'You may upload relevant financial documents such as a bank transaction record proof.',
  auth_document_upload_guidelines_content_2:
    'These documents are only used to verify your identity as part of the registration process.',
  please_select_your_region: 'Please select your region',
  download_template: 'Download Template',
  download_template_img: 'Download Template (image)',
  download_template_pdf: 'Download Template (PDF)',
  copy_template_link: 'Copy this link to download the template',
  front_only: 'Front only',
  front_and_back: 'Front and Back',
  thai_national_id_card: 'Thai National ID Card',
  authorization_document: 'Authorization Document',
  please_select: 'Please select',
  please_upload: 'Please upload ',
  please_select_image: 'Please select image',
  enterprise_service_agreement_certification: 'Service Agreement Certification',
  please_confirm_that_your_id_type: 'Please confirm your ID Type：',
  personal_accounts: 'For Personal Accounts',
  enterprise_accounts: 'For Enterprise Accounts',
  for_thailand_enterprise: 'For Thailand Enterprise',
  Service_Agreement_Certification: 'Service Agreement Certification',
  add_bank_account: '+ Add Bank Account',
  document_need: 'This document must be submitted if the registrant is not a company director.',
  document_procedure: 'Procedure:',
  copy_document_notice_1: '1.Copy the link to your browser to download the template',
  download_document_notice_1: '1.Download the template (PDF/image formats supported)',
  document_notice_2: '2.Complete the form and affix the company seal',
  document_notice_3:
    '3.Upload scanned copy/photo (must have legible text and clear seal; accepted formats: JPG/JPEG/PNG/WEBP images）',
  copy_success: 'Copy succeeded, please open your browser to download.',
  copy_fail: 'Copy failed, please try again later.',
  // 注销账户相关
  deactivate_account: 'Deactivate Account',
  pop_deactivate_title: 'Account Deactivation',
  pop_deactivate_account_content_start:
    'Before you deactivate your account, please carefully read the following points:',
  pop_deactivate_account_content_1:
    'Once you choose to deactivate your account, the account and all related data, including personal information, settings, history, etc., will be permanently deleted. Please consider this carefully.',
  pop_deactivate_account_content_2:
    'There will be a 90-day cooling-off period after account deactivation. After this period ends, you will no longer be able to log in to the application. Please verify that you truly no longer need this account and its data.',
  pop_deactivate_account_content_3:
    'If you log in to the app within 90-day, the deactivation process will be interrupted, and the account will not be deactivated. You will need to initiate the deactivation process again.',
  pop_deactivate_account_content_4:
    'We value your privacy and data security. After deactivating your account, we will no longer retain your personal data.',
  pop_deactivate_account_content_5:
    'If you need to use our services in the future, you will need to register for a new account. The previous account and data will no longer be available. Before deactivating your account, please make sure you have backed up any important information. If you have any questions or need help with the account deactivation process, please contact our customer service team.',
  pop_deactivate_account_content_end: 'Thank you for choosing our services!',
  cannot_be_deactivated: 'Your account cannot be deactivated',
  cannot_be_deactivated_title:
    'To protect your funds and account security, your account cannot be deactivated at this time for the following reasons:',
  cannot_be_deactivated_content: 'Your account balance is not zero.',
  ok: 'OK',
  verify: 'Verify',
  exit: 'Exit',
  deactivate_successful: 'Deactivation Successful',
  deactivate_successful_title:
    'Your account has entered a 90-day cooldown period and will be permanently deleted after this period.',
  important_information: 'Important Information:',
  important_information_1:
    'Once deactivated, all account data — including personal information, settings, and history — will be permanently deleted.',
  important_information_2:
    'There will be a 90-day cooling-off period after account deactivation. After this period ends, you will no longer be able to log in to the application. Please verify that you truly no longer need this account and its data.',
  important_information_3:
    'Logging in within 90-day will cancel the deactivation, and you’ll need to start the process again.',
  important_information_4: 'After deletion, we will no longer store your personal data.',
  important_information_5:
    'To use our services again, you must create a new account. Your previous data cannot be recovered.',
  verify_it_is_you: 'Verify it’s you',
  enter_your_phone: 'Enter your phone number to receive a verification code.',
  account_recovery_reminder: 'Account recovery reminder',
  account_reactivated_content: 'You have interrupted the account cancellation process. Your account has been restored.',

  proceed_to_verification: 'Proceed to Verification',
  registrant_identity_confirmation: 'Registrant Identity Confirmation',
  submit_success: 'Verification Successful! ',
  submit_success_content1: 'Your information has been received and is now under review.',
  submit_success_content2:
    'Our team processes submissions between 8:00 AM and 10:00 PM and will review yours within 1 hour during these hours.',
  submit_success_content3: 'For any questions, feel free to contact us at:',
  enhanced_kyc_requires_verification: 'Enhanced KYC requires verification of the registrant’s information.',
  please_confirm_that_you_are: 'Please confirm that you are:',
  top_up_time_toast: 'Within 2 working hours',
  continue: 'continue',
  set_up_pin: 'Set Up PIN',
  face_authentication: 'Face Authentication',
  verification_failed: 'Verification Failed',
  verification_failed_tips:
    'Authentication failed. Please confirm that you are:  {name}. ID number: {id}. If your information is incorrect, please submit a manual review.',
  submit_for_manual_review: 'Submit for Manual Review',
  manual_review_request: 'Manual Review Request',
  select_reason_for_appeal: 'Please select your appeal reason:',
  incorrect_name_or_ID: 'Incorrect name/ID number entered',
  incorrect_document_information: 'Incorrect document information',
  other_reasons: 'Other reasons',
  submit_request: 'Submit Request',
  remind_me_later: 'Remind me later',
  pop_set_pin_content: 'To better protect your transactions, please set up a PIN for your account.',
  issue_13_tips: 'Please upload the ID Document you used during registration.',
  face_required_tips: 'Setting a payment PIN requires facial recognition.',
  otp_required_tips: 'Setting up PIN requires OTP verification.',
  create_your_pin_for: 'Please set a 6-digit PIN for your account.',
  create_your_pin_confirm: 'Please confirm your 6-digit PIN.',
  pin_no_match: 'PIN do not match. Please re-enter.',
  pin_setup_complete: 'PIN Setup Complete',
  pin_setup_complete_content: 'Congratulations! Your PIN setup iscomplete. Your payments are now even more  secure.',
  done: 'Done',
  set_now: 'Set Now',
  forgot_pin: 'Forgot PIN?',
  user_face_pay: 'Use Facial Authentication',
  enter_pin: 'Enter Pin',
  enter_payment_pin: 'Please enter a 6-digit PIN.',
  please_complete_face: 'To better protect your transactions, please complete face authentication',
  verification_code_to_phone: 'Enter the verification code sent to your phone.',
  verify_old_pin: 'Verify Old PIN',
  input_your_old_pin: 'Please input your old PIN',
  verify_with_old_pin: 'Verify with Old PIN',
  facial_authentication: 'Facial Authentication',
  otp_verification: 'OTP Verification',
  pin_verification_method:
    'For your security, please verify your identity before setting up a new PIN. Choose your preferred verification method.',
  face_try_again_later:
    'Face verification failed too many times. This feature has been temporarily locked. Please try again in {time} minutes.',
  not_now: 'Not Now',
  upgrade_to_unlock: 'Upgrade to Unlock',
  forgot_to_unlock:
    'Too many incorrect PIN attempts. Your account has been locked. Please click "Forgot PIN" to reset it.',
  upgrade_to_unlock_pin:
    'Too many incorrect PIN attempts. Your account has been locked. To ensure account security, please complete the upgrade verification. Once verified, your PIN will be automatically unlocked and your transaction limit will be increased.',
  upgrade_to_unlock_pin_in_audit:
    'Your PIN reset and account upgrade request is pending review.\n' +
    '\n' +
    'You will be unable to initiate transactions until the approval is complete. Our team processes submissions between 8:00 AM and 10:00 PM, and we aim to review your request within 1 hour during this window.\n' +
    '\n' +
    'For any questions, please feel free to contact us at: \n' +
    'onboard@bluepay.asia',
  please_complete_facial: 'To better protect your transactions, please complete facial authentication.',
  your_facial_authentication_is_undergoing_review:
    'Your facial authentication is undergoing review. You will be unable to initiate transactions until the approval is complete. Our team processes submissions between 8:00 AM and 10:00 PM, and we aim to review your request within 1 hour during this window.For any questions, please feel free to contact us at: onboard@bluepay.asia',
  pin_must_be: 'PIN must be a 6-digit non-sequential, non-repeating number.',
  face_fail_to_try_again: 'Face authentication failed. Please try again.',
  pin_unlocked_successfully: 'PIN unlocked successfully, you can proceed with the transaction.',
  large_trans_tip:
    'Large transactions require facial recognition. To better protect your transaction security, please complete your account upgrade verification.',
  pin_unlock_success:
    'Your PIN reset and account upgrade have been completed. You may now proceed with your transactions',
  ...privacy,
  ...termsOfService,
  ...spacialRules,
  ...protocol,
  ...KycPrivacy,
  ...serviceCertification
}

export default en
